import React from 'react';
import { Typography, IconButton, Card, CardContent, Button } from '@mui/material';
import { PlayArrowRounded } from '@mui/icons-material';
import { CallToAction } from '../../types/blocks/carousel';
import { CardMedia } from '../../types/blocks/card';
import { VideoModal } from '../elements/video-modal';
import { useState } from 'react';

interface CourseCardProps {
  title: string;
  onDetailsClick?: () => void;
  callToAction: CallToAction | undefined;
  mediaList?: CardMedia[];
}

export const CoursePromoCard: React.FC<CourseCardProps> = ({
  title,
  onDetailsClick,
  callToAction,
  mediaList,
}) => {
  const [selectedVideo, setSelectedVideo] = useState<{
    playbackId: string;
    playbackToken: string;
    title: string | null;
  } | null>(null);

  const handlePlay = () => {
    if (mediaList && mediaList.length > 0) {
      const media = mediaList[0];
      if (media.muxPlaybackId && media.muxPlaybackToken) {
        setSelectedVideo({
          playbackId: media.muxPlaybackId,
          playbackToken: media.muxPlaybackToken,
          title: media.title,
        });
      }
    }
  };

  return (
    !!callToAction && (
      <>
        <Card
          className="min-w-[234px] h-[300px] flex flex-col rounded-[10px] overflow-hidden relative bg-cover bg-center"
          style={{
            backgroundImage: `url(${callToAction.image?.url})`,
          }}
        >
          <div
            className="inset-0 absolute"
            style={{
              background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%)',
            }}
          />
          <CardContent className="p-6 flex flex-col justify-end h-full z-10">
            <div className="flex flex-col justify-end items-center">
              <IconButton
                size="medium"
                color="secondary"
                className="button-icon-contained button-icon-secondary h-[44px] px-2 absolute inset-0 m-auto"
                sx={{ width: '44px !important' }}
                onClick={handlePlay}
                disabled={
                  !mediaList || !mediaList[0]?.muxPlaybackId || !mediaList[0]?.muxPlaybackToken
                }
              >
                <PlayArrowRounded className="h-[18px]" />
              </IconButton>

              <Typography
                variant="s2"
                align="center"
                color="primaryText"
                className="truncate max-w-[180px]"
              >
                {title}
              </Typography>

              <Button
                variant="outlined"
                color="secondary"
                size="small"
                onClick={onDetailsClick}
                sx={{ mt: 2 }}
              >
                <Typography variant="button-s" className="text-nowrap">
                  {callToAction.text}
                </Typography>
              </Button>
            </div>
          </CardContent>
        </Card>
        {selectedVideo && (
          <VideoModal
            isOpen={!!selectedVideo}
            onClose={() => setSelectedVideo(null)}
            playbackId={selectedVideo.playbackId}
            playbackToken={selectedVideo.playbackToken}
          />
        )}
      </>
    )
  );
};
